/**
* 基础菜单 营销管理 专属商城管理 设置商城分类
*/
<template>
  <div class="contianer">
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.area_sort_name" placeholder="分类名称" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button size="small" type="success" @click="adddiscount">新增</el-button>
        <el-button size="small" type="info" @click="editdiscount">修改</el-button>
        <el-button size="small" type="danger" @click="deldiscount">删除</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 530px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                element-loading-text="拼命加载中" style="width: 70%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="area_sort_name" label="商城分类名称" min-width="220" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="seq" label="排序号" width="300" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="create_name" label="创建人" width="180">
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="150">
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="dialogTitle"
               :visible.sync="infoDialogVisible"
               width="30%"
               :before-close="handleClose"
               center>
      <el-form label-width="155px" :model="flashForm" :rules="rules" ref="flashForm" class="flashForm">
        <el-form-item label="商城分类名称" prop="area_sort_name" class="relative r50">
          <el-input size="small" v-model="flashForm.area_sort_name" auto-complete="off" clearable maxlength="100"
                    placeholder="请输入商城分类名称"></el-input>
        </el-form-item>
        <el-form-item label="排序号" prop="seq">
          <el-input v-model="flashForm.seq" auto-complete="off" clearable maxlength="11" placeholder="请输入排序号">
          </el-input>
        </el-form-item>
        <el-form-item label="PC端Banner图" prop="sort_image_url" class="list_pic_url">
          <el-upload
            class="avatar-uploader"
            action="#"
            :on-remove="handleRemove"
            :show-file-list="false"
            :http-request="handleUpload"
            :before-upload="beforeUpload"
          >
            <img v-if="form.image" :src="form.image" class="avatar"/>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <div class="imgtext">
          用于PC版专属商城顶部展示banner，图片尺寸142px*116px，单张图片大小不得超过1M，仅支持jpg、jpeg、png格式
        </div>
        <el-form-item label="手机端Banner图" prop="phone_sort_image_url" class="list_pic_url">
          <el-upload
            class="avatar-uploader"
            action="#"
            :on-remove="handleRemove"
            :show-file-list="false"
            :http-request="handleUpload"
            :before-upload="beforeUpload2"
          >
            <img v-if="form2.image" :src="form2.image" class="avatar"/>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <div class="imgtext">
          用于移动版专属商城顶部展示banner，图片尺寸80px*80px，单张图片大小不得超过1M，仅支持jpg、jpeg、png格式
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveSort('flashForm')" :disabled="!isCanSubmit">保存</el-button>
            <el-button @click="handleClose()">取 消</el-button>

      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    areaSortList,
    areaSortAdd,
    areaSortUpdate,
    areaSortDetail,
    areaSortDelete
  } from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import {getToken, param} from "../../api/commonMG";
  import {uploadFile} from "../../utils/util";

  export default {
    data: () => {
      var validateNum = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入排序号'));
        } else if (!(/(^[1-9]\d*$)/.test(value))) {
          return callback(new Error('请输入正整数'));
        } else {
          return callback();
        }
      };
      return {
        loading: false, //是显示加载
        infoDialogVisible: false,  // 弹窗
        dialogTitle: '',  // 标题
        selectTableData: [],
        productId: '',
        formInline: {
          page: 1,
          rows: 10,
          activity_zone_id: '',
          area_sort_name: '',
        },
        flashForm: {
          id: '',
          area_sort_name: '',
          seq: '',
          sort_image: '',
          phone_sort_image: '',
          sort_image_url: '',
          phone_sort_image_url: '',
          activity_zone_id: ''
        },
        rules: {
          area_sort_name: [{required: true, message: '请输入商城分类名称', trigger: 'blur'}],
          seq: { required: true, validator: validateNum, trigger: 'blur' },
          sort_image_url: { required: true, message: '请选择PC端Banner图', trigger: 'blur' },
          phone_sort_image_url: { required: true, message: '请选择手机端Banner图', trigger: 'blur' },
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        isCanSubmit: true,
        form: {
          image: ''
        },
        form2: {
          image: ''
        },
        imgUrl: '',
        imgUrl2: '',
        small: true,
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline);
      this.id = this.$route.query.id;
      if (this.$route.query.id) {
        localStorage.setItem('activity_zone_id', this.$route.query.id)
      }
    },
    mounted() {
      if (!this.id) {
        this.id = localStorage.getItem('activity_zone_id')
      }
      this.formInline.activity_zone_id = this.id;
    },

    methods: {
      // 获取公司列表
      getdata() {
        this.loading = true
        areaSortList(this.formInline)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      // 新增商城分类
      adddiscount() {
        this.infoDialogVisible = true;
        this.dialogTitle = '新增商城分类';
        this.form.image = '';
        this.form2.image = '';
        this.flashForm = {
          id: '',
          area_sort_name: '',
          seq: '',
          sort_image: '',
          phone_sort_image: '',
          sort_image_url: '',
          phone_sort_image_url: '',
          activity_zone_id: ''
        };
      },
      // 修改商城分类
      editdiscount() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.dialogTitle = '修改商城分类';
        this.infoDialogVisible = true;
        this.productId = this.selectTableData[0].id;
        this.detail(this.selectTableData[0].id);
      },
      detail(id) {
        this.loading = true
        areaSortDetail(id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if(res.content) {
                this.form.image = res.content.sort_image_url;
                this.form2.image = res.content.phone_sort_image_url;
                this.flashForm = res.content
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 删除商城分类
      deldiscount() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        const title = '是否删除商城分类？';
        this.$confirm(title, '删除商城分类', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          areaSortDelete(this.selectTableData[0].id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      // 商城分类-保存
      saveSort(formName) {
        if (!this.id) {
          this.id = localStorage.getItem('activity_zone_id')
        }
        this.flashForm.activity_zone_id = this.id;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isCanSubmit = false;
            this.loading = true;
            if (this.dialogTitle == '新增商城分类') {
              areaSortAdd(this.flashForm)
                .then(res => {
                  this.isCanSubmit = true;
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功增加商城分类!'
                    });
                    this.handleClose()
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.isCanSubmit = true;
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            } else {
              this.flashForm.id = this.productId;
              areaSortUpdate(this.flashForm)
                .then(res => {
                  this.isCanSubmit = true;
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功修改商城分类!'
                    });
                    this.handleClose()
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.isCanSubmit = true;
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            }
          } else {
            console.log('error submit!!');
          }
        });
      },
      // 搜索事件
      search() {
        this.formInline.page = 1;
        this.getdata(this.formInline)
      },
      handleRemove(file) {
        console.log(file);
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      handleClose() {
        this.$refs["flashForm"].resetFields();
        this.infoDialogVisible = false;
      },
      // PC端Banner图
      beforeUpload(file) {
        const isJPG = file.type === "image/jpeg" || file.type == "image/png" || file.type == "image/jpg";
        const isLt2M = file.size / 1024 / 1024 < 1;
        if (!isJPG) {
          this.$message.error("上传图片只能是 JPG、JPEG 或 PNG 格式!");
          return;
        }
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 1M!");
          return;
        }
        // 调用[限制图片尺寸]函数
        this.limitFileWH(142, 116, file)
      },
      // 限制图片尺寸
      limitFileWH(E_width, E_height, file) {
        const _this = this
        let imgWidth = ''
        let imgHight = ''
        const isSize = new Promise(function (resolve, reject) {
          const width = E_width
          const height = E_height
          const _URL = window.URL || window.webkitURL
          const img = new Image()
          img.onload = function () {
            imgWidth = img.width
            imgHight = img.height
            const valid = img.width === width && img.height === height
            valid ? resolve() : reject()
          }
          img.src = _URL.createObjectURL(file)
        }).then(() => {
          getToken().then(res => {
            if(res) {
              let result = uploadFile(res,file);
              result.then(res => {
                this.imgUrl =  res.data.content.file.fileUrl;
                this.flashForm.sort_image = res.data.content.file.accessoryId;
                this.flashForm.sort_image_url = res.data.content.file.fileUrl;
                //对返回的图片地址进行回显
                this.$set(this.form, "image",  res.data.content.file.fileUrl);
              })
            }
          });
          //阻止传到本地浏览器
          return false;
        }, () => {
          _this.$message.error({
            message: '上传图片的尺寸应为' + E_width + '*' + E_height + '，当前上传图片的尺寸为：' + imgWidth + '*' + imgHight,
            btn: false
          })
          return false
        })
        return isSize
      },
      // 手机端Banner图
      beforeUpload2(file) {
        const isJPG2 = file.type === "image/jpeg" || file.type == "image/png" || file.type == "image/jpg";
        const isLt2M = file.size / 1024 / 1024 < 1;
        if (!isJPG2) {
          this.$message.error("上传图片只能是 JPG、JPEG 或 PNG 格式!");
          return;
        }
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 1M!");
          return;
        }
        // 调用[限制图片尺寸]函数
        this.limitFileWH2(80, 80, file)
      },
      // 限制图片尺寸
      limitFileWH2(E_width, E_height, file) {
        const _this = this
        let imgWidth = ''
        let imgHight = ''
        const isSize = new Promise(function (resolve, reject) {
          const width = E_width
          const height = E_height
          const _URL = window.URL || window.webkitURL
          const img = new Image()
          img.onload = function () {
            imgWidth = img.width
            imgHight = img.height
            const valid = img.width === width && img.height === height
            valid ? resolve() : reject()
          }
          img.src = _URL.createObjectURL(file)
        }).then(() => {
          getToken().then(res => {
            if(res) {
              let result = uploadFile(res,file);
              result.then(res => {
                this.imgUrl2 =  res.data.content.file.fileUrl;
                this.flashForm.phone_sort_image = res.data.content.file.accessoryId;
                this.flashForm.phone_sort_image_url = res.data.content.file.fileUrl;
                //对返回的图片地址进行回显
                this.$set(this.form2, "image",  res.data.content.file.fileUrl);
              })
            }
          });
          //阻止传到本地浏览器
          return false;
        }, () => {
          _this.$message.error({
            message: '上传图片的尺寸应为' + E_width + '*' + E_height + '，当前上传图片的尺寸为：' + imgWidth + '*' + imgHight,
            btn: false
          })
          return false
        })
        return isSize
      },
      // 可以获取图片参数
      handleUpload(file) {
        console.log(file)
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.area_sort_name == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      }
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .flashForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .flashForm .el-input {
    width: 320px;
  }

  /deep/ .flashForm .el-input--small {
    width: 320px;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .flashForm .el-form-item__label {
    position: relative;
    padding: 0 22px 0 0 !important;
  }

  /deep/ .flashForm .el-select-dropdown__list {
    padding-bottom: 50px;
    min-height: 150px;
  }

  /deep/ .flashForm .el-select-dropdown__item {
    width: 320px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /deep/ .el-dialog--center {
    border-radius: 8px !important;
  }

  /deep/ .el-message-box__title {
    color: #409EFF !important;
  }

  /deep/ .el-dialog__title {
    color: #409EFF !important;
  }

  .avatar {
    width: 318px;
    height: 120px;
    display: block;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 318px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    border: 1px dashed #DCDFE6;
  }

  .avatar-uploader {
    height: 122px;
  }

  .imgtext {
    color: red;
    font-size: 12px;
    margin-left: 152px;
    width: 308px;
    margin-bottom: 20px
  }

</style>





// WEBPACK FOOTER //
// src/views/store/ificationGaining.vue